angular.module('bmsApp.settings')
	.controller('EcomRouteConfigurationCtrl', EcomRouteConfigurationCtrl);

EcomRouteConfigurationCtrl.$inject = [
	'$scope',
	'$state',
	'$q',
	'notify',
	'LicenseOptionsSvc',
	'EcomRouteConfigurationSvc',
	'LicenseDetailSvc',
];

function EcomRouteConfigurationCtrl($scope, $state, $q, notify, LicenseOptionsSvc, EcomRouteConfigurationSvc,LicenseDetailSvc) {
	let self = this;
	let handlers = {};

	angular.extend(self, {
		loading: null,
		handlers: handlers,
		options: {},
	});

	this.$onInit = () => {
		let promises = {
			licenses: LicenseOptionsSvc.license()
				.then((response) => {
					self.options.licenses = response.data.options;
				}),
		};
		$q.all(promises)
			.then((response) => {
				self.loading = false;
			});

	};


	// Handlers --------------------------------------------------------------------------------------------------------
	

	

	handlers.licenseChanged = () => {
		self.loading = true;
		EcomRouteConfigurationSvc.read(self.license.id)
			.then((response) => {
				self.ecom_route_configuration = response.data.ecom_route_configuration;
				self.loading = false;
			});
	};

	handlers.submitClick = function () {
		EcomRouteConfigurationSvc.save(self.ecom_route_configuration)
			.then((response) => {
				notify({
					message: 'Ecom route configuration successfully saved'
				});
			},function (error) {
					processing = false;
					$scope.errors = error;
				});
	};
}